// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.complianceDocumentDefinitions', {
    url: '/reports-certificates',
    controller: 'ComplianceDocumentDefinitionsConfigurationController as vm',
    templateUrl:
      'main/configuration/complianceDocumentDefinitions/complianceDocumentDefinitions.tpl.html',
    data: { pageTitle: 'Certificates & reports' },
  });
};

class ComplianceDocumentDefinitionsConfigurationController {
  constructor(currentOrganization) {
    'ngInject';
    this.folderId = currentOrganization.folderId;
  }
}

angular
  .module('configuration.complianceDocumentDefinitions', [])
  .config(config)
  .controller(
    'ComplianceDocumentDefinitionsConfigurationController',
    ComplianceDocumentDefinitionsConfigurationController,
  );
